import React, { useEffect, useMemo, useState } from "react";
import { ROUTES } from "constants/routes-path";
import {
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    Input,
    LightMode,
    Stack,
    Tab,
    Tabs,
    TabList,
    TabPanel,
    TabPanels,
    Text,
    useColorModeValue
} from "@chakra-ui/react";
import CardHeader from "components/Card/CardHeader";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { checkErrors } from "utils/forms-utils";
import { SearchIcon } from "@chakra-ui/icons";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";

const QueriesViolationHistory = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const textColor = useColorModeValue("gray.700", "white");
    const formSpacing = "30px";
    const translationKey = "queries";
    const formTranslationKey = `${translationKey}.form`;
    const formDirection = { sm: "column", md: "row" };
    const [formData, setFormData] = useState(undefined);
    const [inputError, setInputError] = useState({});

    const ids = useMemo(() => ({ numeroAit: "numero-ait" }), []);

    const initFormData = () => ({
        [ids.numeroAit]: {
            value: "",
            validations: [{ required: true }],
        }
    });

    const handleSearch = () => {
        navigate(
            ROUTES.transportManagementPath + ROUTES.searches + ROUTES.searchViolationHistory + ROUTES.searchAit +
            `?valor=${formData[ids.numeroAit].value}`
        );
    };

    const handleClear = () => {
        setFormData(initFormData());
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        const newFormData = {
            ...formData,
            [id]: { ...formData[id], value: value.toUpperCase() },
        };
        setFormData(newFormData);
        setInputError(checkErrors({ formData: newFormData, inputError, name: id }));
    };

    useEffect(() => {
        setFormData(initFormData());
    }, []);

    return (
        <Flex gap="5" direction="column" minH="89vh" align="center" pt={{ sm: "150px", md: "90px" }}>
            {formData && (
                <Card overflowX={{ sm: "scroll", lg: "hidden" }}>
                    <CardHeader mb="40px">
                        <Text color={textColor} fontSize="lg" fontWeight="bold">
                            {t(`${translationKey}.title.query-violation-history-detran`)}
                        </Text>
                    </CardHeader>
                    <CardBody>
                        <Tabs>
                            <TabList mb="1em">
                                <Tab>{t(`${formTranslationKey}.title.query-by-ait`)}</Tab>
                            </TabList>
                            <TabPanels>
                                <TabPanel>
                                    <Stack spacing={formSpacing} direction={formDirection}>
                                        <FormControl isRequired isInvalid={inputError[ids.numeroAit]}>
                                            <Input
                                                fontSize="sm"
                                                id={ids.numeroAit}
                                                name={ids.numeroAit}
                                                value={formData[ids.numeroAit].value}
                                                onChange={handleInputChange}
                                                placeholder={t(`${formTranslationKey}.fields.violation-number.placeholder`)}
                                            />
                                            <FormErrorMessage>
                                                {t(inputError[ids.numeroAit])}
                                            </FormErrorMessage>
                                        </FormControl>

                                        <LightMode>
                                            <Button
                                                px="10"
                                                variant="dark"
                                                fontSize="sm"
                                                isDisabled={!formData[ids.numeroAit].value}
                                                leftIcon={<SearchIcon />}
                                                onClick={handleSearch}
                                                _hover={!formData[ids.numeroAit].value ? {} : undefined}
                                            >
                                                {t("system.actions.search")}
                                            </Button>
                                        </LightMode>

                                        <LightMode>
                                            <Button
                                                px="10"
                                                variant="dark"
                                                fontSize="sm"
                                                isDisabled={!formData[ids.numeroAit].value}
                                                onClick={handleClear}
                                                _hover={!formData[ids.numeroAit].value ? {} : undefined}
                                            >
                                                {t("system.actions.clear")}
                                            </Button>
                                        </LightMode>
                                    </Stack>
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </CardBody>
                </Card>
            )}
        </Flex>
    );
};

export default QueriesViolationHistory;
